import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useHayMasALosLados } from '../lib/hayMasALosLados';

/**
 * UNA FILA QUE SE DESLIZA, CON FLECHAS (Enrique, 16-10). Cuando lo que va en la fila no cabe,
 * una flecha sobre un degradado en el borde por el que quedan más; desaparece al llegar al
 * final, y la de la izquierda sale en cuanto se ha avanzado. Tocarla avanza la fila.
 *
 * La usan las categorías de «Elijo yo» y los filtros de «Elige tu menú».
 *
 * - `className`: las clases de la fila que se desliza (el `overflow-x-auto` va ahí).
 * - `fondo`: el color del degradado, el mismo que el fondo de detrás.
 * - `bordes`: dónde van las capas, `{ izq, der }` (p. ej. `-left-4` si la fila sangra).
 * - `paso`: cuánto avanza un toque, en píxeles.
 * - `claseCapa`: clases extra de la capa (p. ej. `lg:hidden`, o un `pb-` para centrar la flecha).
 */
const FilaConFlechas = ({
    className, children, fondo = '#161616', bordes = { izq: 'left-0', der: 'right-0' },
    paso = 200, claseCapa = '', etiquetas = { izq: 'Ver los anteriores', der: 'Ver más' }, ...props
}) => {
    // Lo que queda a cada lado lo mide `lib/hayMasALosLados`, el mismo de las tablas.
    const { ref, medir: mirar, hay } = useHayMasALosLados(4);
    const mover = (sentido) => {
        const el = ref.current;
        if (el?.scrollBy) el.scrollBy({ left: sentido * paso, behavior: 'smooth' });
    };
    const capa = (lado) => (
        <div className={`absolute top-0 bottom-0 ${bordes[lado]} w-16 flex items-center pointer-events-none ${lado === 'der' ? 'justify-end pr-1' : 'justify-start pl-1'} ${claseCapa}`}
            style={{ background: `linear-gradient(to ${lado === 'der' ? 'right' : 'left'}, transparent, ${fondo} 55%)` }}>
            <button type="button" aria-label={etiquetas[lado]} onClick={() => mover(lado === 'der' ? 1 : -1)}
                className="pointer-events-auto w-8 h-8 rounded-full bg-[#2c2c2c] text-foreground flex items-center justify-center shadow"
                data-testid={`fila-flecha-${lado}`}>
                {lado === 'der' ? <ChevronRight className="w-3.5 h-3.5" strokeWidth={2.5} /> : <ChevronLeft className="w-3.5 h-3.5" strokeWidth={2.5} />}
            </button>
        </div>
    );
    return (
        <div className="relative">
            <div ref={ref} onScroll={mirar} className={className} {...props}>{children}</div>
            {hay.izq && capa('izq')}
            {hay.der && capa('der')}
        </div>
    );
};

export default FilaConFlechas;
